import { render, staticRenderFns } from "./courseLearningRatesixthxbk.vue?vue&type=template&id=6c97706a&scoped=true"
import script from "./courseLearningRatesixthxbk.vue?vue&type=script&lang=js"
export * from "./courseLearningRatesixthxbk.vue?vue&type=script&lang=js"
import style0 from "./courseLearningRatesixthxbk.vue?vue&type=style&index=0&id=6c97706a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c97706a",
  null
  
)

export default component.exports